export const getAuthUserData = (reduxUser) => {
  if (reduxUser) return reduxUser;

  const storedUser = localStorage.getItem('useralbaraqawy');
  if (!storedUser) return null;

  try {
    return JSON.parse(storedUser);
  } catch {
    return null;
  }
};

const getUserPermissions = (userData) => {
  if (Array.isArray(userData?.data?.permissions)) return userData.data.permissions;
  if (Array.isArray(userData?.permissions)) return userData.permissions;
  if (Array.isArray(userData?.data?.data?.permissions)) return userData.data.data.permissions;
  return [];
};

const getUserRoles = (userData) => {
  if (Array.isArray(userData?.data?.roles)) return userData.data.roles;
  if (Array.isArray(userData?.roles)) return userData.roles;
  if (Array.isArray(userData?.data?.data?.roles)) return userData.data.data.roles;
  return [];
};

const getPermissionName = (permission) => {
  if (typeof permission === 'string') return permission;
  return permission?.name || permission?.slug || permission?.key || '';
};

const getRoleName = (role) => {
  if (typeof role === 'string') return role;
  return role?.name || role?.slug || role?.key || '';
};

export const hasAnyPermission = (userData, ...permissionNames) => {
  const userPermissions = getUserPermissions(userData).map(getPermissionName);
  const userRoles = getUserRoles(userData).map(getRoleName);

  const isAdmin = userRoles.some((roleName) =>
    ['admin', 'administrator'].includes(String(roleName).toLowerCase())
  );

  if (isAdmin) return true;
  return permissionNames.some((permissionName) => userPermissions.includes(permissionName));
};

export const getReadableError = (error, fallback = 'حدث خطأ غير متوقع') => {
  if (!error) return fallback;
  if (typeof error === 'string') return error;
  if (error?.response?.status === 401) return 'انتهت جلسة الدخول أو لا يوجد تسجيل دخول صالح';
  if (error?.response?.status === 403) return 'ليس لديك صلاحية لتنفيذ هذه العملية';
  if (error?.response?.status === 404) return 'البيانات المطلوبة غير موجودة أو تم حذفها';
  if (error?.response?.status >= 500) return 'حدث خطأ في الخادم، برجاء المحاولة لاحقاً';

  const responseData = error?.response?.data;
  if (responseData) return getReadableError(responseData, fallback);

  const validationErrors = error?.errors;
  if (validationErrors && typeof validationErrors === 'object') {
    const firstEntry = Object.entries(validationErrors).find(([, value]) => {
      const messages = Array.isArray(value) ? value : [value];
      return messages.some(Boolean);
    });
    if (firstEntry) {
      const [field, value] = firstEntry;
      const firstError = (Array.isArray(value) ? value : [value]).find(Boolean);
      return `${field}: ${firstError}`;
    }
  }

  if (typeof error?.message === 'string') return error.message;
  if (typeof error?.error === 'string') return error.error;

  return fallback;
};
